import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import vehicleTypeService from '../services/vehicle-type.service';
import { setMessage } from './message';
export const fetchVehicleTypeList = createAsyncThunk(
    'vehicleType/fetchVehicleTypeList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await vehicleTypeService.getVehicleTypeList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchVehicleTypeDropdown = createAsyncThunk(
    'vehicleType/fetchVehicleTypeDropdown',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await vehicleTypeService.getVehicleTypeDropdown(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchArchivedVehicleTypeList = createAsyncThunk(
    'vehicleType/fetchArchivedVehicleTypeList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await vehicleTypeService.getVehicleTypeArchiveList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const createVehicleType = createAsyncThunk(
    'vehicleType/createVehicleType',
    async (vehicleTypeData, thunkAPI) => {
        try {
            const response = await vehicleTypeService.addVehicleType(vehicleTypeData);
            return response.data; // Assuming response contains the created die group data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const updateVehicleType = createAsyncThunk(
    'vehicleType/updateVehicleType',
    async ({ id, values }, thunkAPI) => {
        try {
            const response = await vehicleTypeService.updateVehicleType(id, values);
            thunkAPI.dispatch(fetchVehicleTypeList({ page: 1, limit: 10 })); // Re-fetch list after update
            return response.data; // Return the updated die group data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const deleteVehicleType = createAsyncThunk(
    'vehicleType/deleteVehicleType',
    async (id, thunkAPI) => {
        try {
            await vehicleTypeService.deleteVehicleType(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const unArchiveVehicleType = createAsyncThunk(
    'vehicleType/unArchiveVehicleType',
    async (id, thunkAPI) => {
        try {
            await vehicleTypeService.unArchiveVehicleType(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const vehicleTypeSlice = createSlice({
    name: 'vehicleType',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetVehicleTypeList: state => {
            state.list = []; // This will clear the list
        },
        resetCurrentVehicleTypePage: state => {
            state.currentPage = 1;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchVehicleTypeList.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchVehicleTypeList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchVehicleTypeList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchVehicleTypeDropdown.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchVehicleTypeDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchVehicleTypeDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });


        builder
            .addCase(fetchArchivedVehicleTypeList.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedVehicleTypeList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedVehicleTypeList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.data =  []; 
                state.list =  [];  
                state.error = action.error.message;
            });
        builder
            .addCase(createVehicleType.pending, state => {
                state.status = 'loading';
            })
            .addCase(createVehicleType.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createVehicleType.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateVehicleType.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateVehicleType.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const updatedGroup = action.payload;
                const index = state.data.findIndex(
                    group => group.id === updatedGroup.id,
                ); // Find the index of the updated group
                if (index !== -1) {
                    state.data[index] = updatedGroup; // Replace the old group with the updated one
                }
            })
            .addCase(updateVehicleType.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(deleteVehicleType.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteVehicleType.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteVehicleType.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveVehicleType.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveVehicleType.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveVehicleType.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetVehicleTypeList, resetCurrentVehicleTypePage } = vehicleTypeSlice.actions;
const { reducer } = vehicleTypeSlice;
export default reducer;
